const Scholar = (scholarships) => {
    const title = `<div class="mt-lg-5 col-12 h2-heading text-center text--white">${scholarships['cat_name']}</div>`;

    const view = scholarships.posts
        .map((scholarship) => {
            return `
                <div class="col-lg-4 col-md-6 mb-5 mb-lg-0 winner-item">

                    <a href="${scholarship['link']}" aria-label="winner-link">
                        ${scholarship['image']}
                    </a>

                    <div class="winner-item__bottom text-center">

                        <a href="${scholarship['link']}" aria-label="winner-link">

                            <div class="winner-item__title">${scholarship['title']}</div>

                            <div class="winner-item__subtitle">${scholarship['description']}</div>

                        </a>

                    </div>

                </div>
          `;
        })
        .join('');
    return title + view;
};

export default Scholar;